import axios from 'axios'
import * as utils from './api-utils'

export default {
  index() {
    return axios.get(utils.getApiUrl('/admin/vehicles'))
  },
  get(id) {
    return axios.get(utils.getApiUrl(`/admin/vehicles/${id}`))
  },
  create(payload) {
    return axios.post(utils.getApiUrl('/admin/vehicles'), payload)
  },
  update(id, payload) {
    return axios.put(utils.getApiUrl(`/admin/vehicles/${id}`), payload)
  },
  delete(id) {
    return axios.delete(utils.getApiUrl(`/admin/vehicles/${id}`))
  },
}
